export enum FiGiphySize {
    original = 0,
    fixed_width = 1,
    fixed_width_small = 2,
    fixed_height = 3,
    fixed_height_small = 4,
}
